<template>
  <div width="250" alt="logo">
    <svg
      vwidth="250"
      ersion="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 726.89 129.45"
      style="enable-background:new 0 0 726.89 129.45;"
      xml:space="preserve"
    >
      <path
        class="st0"
        d="M116.84,43.94c-1.65,0-3.17,0.5-4.44,1.36c-0.05,0.03-0.1,0.08-0.15,0.11c-0.15,0.11-0.31,0.22-0.46,0.34
            c-0.39,0.32-0.75,0.69-1.07,1.08l0,0c-0.64,0.79-1.14,1.7-1.45,2.7c-0.01,0.05-0.03,0.11-0.04,0.15c-0.12,0.42-0.21,0.86-0.26,1.31
            c0,0.04-0.01,0.07-0.02,0.1l0,0c-0.03,0.27-0.04,0.54-0.04,0.82v50.46c0,0.28,0.01,0.55,0.04,0.82c0.06,0.54,0.16,1.06,0.32,1.56
            l0,0c0.23,0.75,0.57,1.45,1,2.09c0.28,0.42,0.61,0.82,0.96,1.18c0.18,0.18,0.37,0.36,0.56,0.52c0.19,0.16,0.39,0.32,0.61,0.46
            c1.27,0.86,2.79,1.36,4.44,1.36h3.92v19.09l19.09-19.09h30.02c2.2,0,4.18-0.89,5.61-2.34c0.09-0.09,0.18-0.19,0.27-0.29
            c0.08-0.09,0.17-0.17,0.24-0.27l0,0c0.16-0.19,0.32-0.4,0.46-0.61c0.43-0.63,0.76-1.34,0.99-2.09c0.08-0.25,0.14-0.51,0.19-0.77
            c0.11-0.52,0.16-1.06,0.16-1.61V51.92c0-0.56-0.06-1.09-0.16-1.61c-0.21-1.04-0.62-2.01-1.19-2.86c-0.14-0.21-0.3-0.41-0.46-0.61
            l0,0c-0.16-0.19-0.33-0.38-0.51-0.56s-0.37-0.35-0.56-0.51c-0.39-0.32-0.81-0.61-1.26-0.86c-1.13-0.61-2.41-0.96-3.78-0.96
            L116.84,43.94L116.84,43.94z"
      ></path>
      <path
        class="st1"
        d="M51.95,44.28l-7.3,15.43c-0.96-0.53-2.03-1.02-3.23-1.46c-1.12-0.44-2.28-0.8-3.47-1.07
            c-0.88-0.18-1.76-0.31-2.63-0.4c-0.8-0.17-1.6-0.26-2.39-0.26c-0.4,0-0.84,0.05-1.32,0.13c-0.4,0-0.8,0.09-1.2,0.26
            c-1.12,0.27-2.11,0.75-2.99,1.46c-0.88,0.62-1.32,1.55-1.32,2.79c0,1.51,0.56,2.66,1.68,3.46c1.2,0.71,2.51,1.24,3.95,1.59
            c0.8,0.26,1.56,0.49,2.27,0.66c0.72,0.09,1.36,0.18,1.92,0.27c5.11,1.15,9.34,3.24,12.69,6.25c3.43,3.02,5.15,7.67,5.15,13.96
            c0,8.69-2.87,15.02-8.62,19.01c-5.75,3.9-12.09,5.98-19.03,6.25c-0.24,0-0.48,0-0.72,0c-0.16,0-0.36,0-0.6,0
            c-4.39,0-8.7-0.66-12.93-1.99c-4.15-1.33-8.1-3.24-11.85-5.72l7.9-17.02c1.36,1.15,2.91,2.21,4.67,3.19
            c1.75,0.89,3.55,1.68,5.39,2.39c1.28,0.44,2.51,0.8,3.71,1.06c1.2,0.27,2.36,0.4,3.47,0.4c0.32,0,0.64,0,0.96,0
            c0.4-0.09,0.8-0.18,1.19-0.26c1.2-0.27,2.28-0.8,3.23-1.6c0.96-0.8,1.44-1.91,1.44-3.32c0-1.95-0.84-3.32-2.52-4.12
            c-1.68-0.89-3.67-1.59-5.98-2.13c-0.88-0.18-1.76-0.36-2.64-0.54c-0.8-0.27-1.63-0.53-2.51-0.8c-3.43-0.97-6.59-2.66-9.46-5.05
            c-2.79-2.48-4.19-6.78-4.19-12.9c0-8.25,2.75-14.32,8.26-18.22c5.5-3.9,11.53-5.9,18.07-5.99c0.16,0,0.28,0,0.36,0
            c0.16,0,0.28,0,0.36,0c3.51,0,6.94,0.36,10.3,1.07c3.43,0.62,6.74,1.73,9.93,3.32C51.95,44.38,51.95,44.28,51.95,44.28z"
      ></path>
      <polygon
        class="st1"
        points="89.39,62.1 89.39,110.36 67.6,110.36 67.6,62.1 60.53,62.1 60.53,42.15 67.6,42.15 67.6,21.68 
            89.39,21.68 89.39,42.15 101.71,42.15 101.71,62.1 "
      ></polygon>
      <polygon
        class="st1"
        points="209.63,0 209.63,66.75 232.26,42.15 262.07,42.15 231.3,73.66 263.98,110.36 233.46,110.36 
            209.63,82.57 209.63,110.36 187.85,110.36 187.85,0 "
      ></polygon>
      <path
        class="st1"
        d="M287.75,66.35H313c-0.56-3.19-2.04-5.76-4.43-7.71c-2.31-1.95-4.95-2.93-7.9-2.93c-3.2,0-5.99,0.93-8.38,2.79
            c-2.39,1.77-3.91,4.43-4.55,7.98L287.75,66.35L287.75,66.35z M333.23,77.79v2.52h-45.85c0,4.96,1.16,8.78,3.47,11.44
            c2.31,2.57,5.7,3.86,10.17,3.86c2.32,0,4.31-0.49,5.99-1.46c1.75-0.97,3.23-2.57,4.43-4.79l20.95-0.13
            c-1.76,8.16-5.67,14.09-11.73,17.82c-5.98,3.72-12.49,5.59-19.51,5.59c-10.14,0-18.59-3.06-25.38-9.18
            c-6.78-6.2-10.18-15.2-10.18-26.99c0-11.35,3.15-20.25,9.46-26.73c6.39-6.47,14.57-9.71,24.54-9.71c10.69,0,18.95,3.42,24.78,10.24
            c5.91,6.82,8.86,16.05,8.86,27.66L333.23,77.79L333.23,77.79z"
      ></path>
      <path
        class="st1"
        d="M376.02,60.9c-4.39,0.09-7.82,1.69-10.29,4.79c-2.48,3.01-3.71,6.6-3.71,10.77c0,4.34,1.23,7.98,3.71,10.9
            c2.47,2.93,5.91,4.39,10.29,4.39c4.47,0,7.9-1.46,10.3-4.39c2.47-2.92,3.71-6.56,3.71-10.9c0-4.16-1.24-7.76-3.71-10.77
            c-2.39-3.1-5.82-4.66-10.3-4.66V60.9z M389.3,110.36v-7.58h-0.24c-1.76,3.19-4.15,5.59-7.18,7.18c-3.03,1.51-6.18,2.35-9.46,2.53
            c-0.32,0.09-0.64,0.13-0.96,0.13c-0.32,0-0.64,0-0.96,0c-9.1,0-16.56-3.59-22.39-10.77c-5.75-7.27-8.62-15.78-8.62-25.53
            s2.84-18.21,8.5-25.4c5.75-7.27,13.17-10.9,22.27-10.9c0.4,0,0.8,0,1.2,0c0.4,0,0.8,0.05,1.2,0.13c3.11,0.27,6.14,1.15,9.1,2.66
            c3.04,1.42,5.55,3.46,7.54,6.12V0h21.79v110.36H389.3z"
      ></path>
      <path
        class="st2"
        d="M472.58,44.28l-7.3,15.43c-0.96-0.53-2.04-1.02-3.23-1.46c-1.12-0.44-2.27-0.8-3.47-1.07
            c-0.88-0.18-1.75-0.31-2.63-0.4c-0.8-0.17-1.6-0.26-2.39-0.26c-0.4,0-0.84,0.05-1.32,0.13c-0.4,0-0.8,0.09-1.2,0.26
            c-1.12,0.27-2.12,0.75-3,1.46c-0.88,0.62-1.32,1.55-1.32,2.79c0,1.51,0.56,2.66,1.68,3.46c1.2,0.71,2.52,1.24,3.95,1.59
            c0.8,0.26,1.55,0.49,2.27,0.66c0.72,0.09,1.36,0.18,1.91,0.27c5.11,1.15,9.34,3.24,12.69,6.25c3.43,3.02,5.15,7.67,5.15,13.96
            c0,8.69-2.88,15.02-8.62,19.01c-5.75,3.9-12.09,5.98-19.04,6.25c-0.24,0-0.48,0-0.72,0c-0.16,0-0.36,0-0.6,0
            c-4.39,0-8.7-0.66-12.93-1.99c-4.15-1.33-8.1-3.24-11.85-5.72l7.9-17.02c1.36,1.15,2.91,2.21,4.67,3.19
            c1.76,0.89,3.55,1.68,5.39,2.39c1.28,0.44,2.52,0.8,3.71,1.06c1.2,0.27,2.36,0.4,3.47,0.4c0.32,0,0.64,0,0.96,0
            c0.4-0.09,0.8-0.18,1.2-0.26c1.2-0.27,2.27-0.8,3.23-1.6c0.96-0.8,1.44-1.91,1.44-3.32c0-1.95-0.84-3.32-2.52-4.12
            c-1.68-0.89-3.67-1.59-5.98-2.13c-0.88-0.18-1.75-0.36-2.63-0.54c-0.8-0.27-1.64-0.53-2.52-0.8c-3.43-0.97-6.58-2.66-9.46-5.05
            c-2.79-2.48-4.19-6.78-4.19-12.9c0-8.25,2.75-14.32,8.26-18.22s11.53-5.9,18.08-5.99c0.16,0,0.28,0,0.36,0c0.16,0,0.28,0,0.36,0
            c3.51,0,6.94,0.36,10.29,1.07c3.43,0.62,6.75,1.73,9.94,3.32v-0.1H472.58z"
      ></path>
      <polygon
        class="st2"
        points="507.98,0 507.98,66.75 530.6,42.15 560.41,42.15 529.65,73.66 562.32,110.36 531.8,110.36 
            507.98,82.57 507.98,110.36 486.19,110.36 486.19,0 "
      ></polygon>
      <path
        class="st2"
        d="M579.38,2.4c3.35,0.08,6.23,1.46,8.62,4.12s3.59,5.85,3.59,9.57S590.4,23,588,25.66s-5.27,3.99-8.62,3.99
            s-6.22-1.33-8.62-3.99s-3.59-5.85-3.59-9.57s1.19-6.91,3.59-9.57c2.39-2.66,5.27-3.99,8.62-3.99V2.4z M590.28,42.15v68.21H568.5
            V42.15H590.28z"
      ></path>
      <rect x="604.73" class="st2" width="21.79" height="110.36"></rect>
      <rect x="640.97" class="st2" width="21.78" height="110.36"></rect>
      <path
        class="st2"
        d="M725.1,44.28l-7.3,15.43c-0.96-0.53-2.03-1.02-3.23-1.46c-1.12-0.44-2.27-0.8-3.47-1.07
            c-0.88-0.18-1.75-0.31-2.63-0.4c-0.8-0.17-1.59-0.26-2.39-0.26c-0.4,0-0.84,0.05-1.32,0.13c-0.4,0-0.8,0.09-1.19,0.26
            c-1.12,0.27-2.12,0.75-2.99,1.46c-0.88,0.62-1.32,1.55-1.32,2.79c0,1.51,0.56,2.66,1.68,3.46c1.2,0.71,2.52,1.24,3.95,1.59
            c0.8,0.26,1.55,0.49,2.27,0.66c0.72,0.09,1.35,0.18,1.91,0.27c5.11,1.15,9.34,3.24,12.69,6.25c3.43,3.02,5.15,7.67,5.15,13.96
            c0,8.69-2.88,15.02-8.62,19.01c-5.75,3.9-12.09,5.98-19.04,6.25c-0.24,0-0.48,0-0.71,0c-0.16,0-0.36,0-0.6,0
            c-4.39,0-8.7-0.66-12.93-1.99c-4.15-1.33-8.1-3.24-11.85-5.72l7.9-17.02c1.36,1.15,2.91,2.21,4.67,3.19
            c1.76,0.89,3.55,1.68,5.39,2.39c1.28,0.44,2.51,0.8,3.71,1.06c1.2,0.27,2.35,0.4,3.47,0.4c0.32,0,0.64,0,0.96,0
            c0.4-0.09,0.8-0.18,1.2-0.26c1.2-0.27,2.27-0.8,3.23-1.6c0.96-0.8,1.44-1.91,1.44-3.32c0-1.95-0.83-3.32-2.51-4.12
            c-1.68-0.89-3.67-1.59-5.99-2.13c-0.88-0.18-1.75-0.36-2.63-0.54c-0.8-0.27-1.64-0.53-2.52-0.8c-3.43-0.97-6.58-2.66-9.46-5.05
            c-2.79-2.48-4.19-6.78-4.19-12.9c0-8.25,2.75-14.32,8.26-18.22s11.53-5.9,18.08-5.99c0.16,0,0.28,0,0.36,0c0.16,0,0.28,0,0.36,0
            c3.51,0,6.94,0.36,10.29,1.07c3.43,0.62,6.75,1.73,9.94,3.32v-0.1H725.1z"
      ></path>
      <path
        class="st3"
        d="M116.84,43.94c-4.39,0-7.93,3.56-7.93,7.98v50.47c0,4.42,3.54,7.98,7.93,7.98h3.92v12.14
            c2.82-0.33,5.62-0.81,8.39-1.44l10.7-10.7h14.54c9.48-6.24,17.46-14.49,23.4-24.16V51.92c0-4.42-3.54-7.98-7.93-7.98H116.84z"
      ></path>
      <path
        class="st4"
        d="M116.84,43.94c-4.39,0-7.93,3.56-7.93,7.98v50.47c0,1.33,0.33,2.58,0.89,3.68c0.68,0.05,1.37,0.08,2.05,0.1
            c16.03-0.01,31.41-6.37,42.76-17.69c2.89-2.91,3.27-3.46,5.13-5.88c8.22-10.6,12.7-23.63,12.73-37.04
            c-0.02-0.39-0.02-0.79-0.04-1.18c-0.81-0.27-1.67-0.43-2.57-0.43L116.84,43.94L116.84,43.94z"
      ></path>
      <path
        class="st5"
        d="M116.84,43.94c-4.39,0-7.93,3.56-7.93,7.98v26.12c0.98,0.09,1.96,0.14,2.94,0.14
            c18.02,0,32.64-14.61,32.64-32.63c-0.01-0.54-0.03-1.08-0.06-1.62L116.84,43.94L116.84,43.94z"
      ></path>
      <path
        class="st6 line1"
        d="M121.84,69.4c-0.17,0-0.35,0.05-0.54,0.16c-1.07,0.58-1.1,0.8-1.16,7.81c-0.06,7.41-0.02,8.09,0.65,8.96
            c0.54,0.71,0.98,0.79,1.68,0.32c0.84-0.57,0.88-0.94,0.88-8.6v-7.12l-0.43-0.67C122.54,69.68,122.21,69.41,121.84,69.4z"
      ></path>
      <path
        class="st6 line2"
        d="M128.59,62.93c-0.43,0-0.85,0.14-1.18,0.43c-1.06,0.94-1.06,1.02-1.06,15.01c0,14.43,0.02,14.59,1.31,15.3
            c0.93,0.51,1.57,0.4,2.37-0.4c0.53-0.53,0.78-1.02,0.88-1.73C131,91,131.04,84.72,131,77.6c-0.06-11.89-0.1-13.01-0.46-13.55
            C130.07,63.33,129.31,62.94,128.59,62.93z"
      ></path>
      <path
        class="st6 line3"
        d="M135.05,69.54c-0.67,0.02-1.34,0.38-1.73,1.1c-0.33,0.61-0.38,1.52-0.38,7.61c0,6.17,0.04,7,0.39,7.63
            c0.22,0.39,0.57,0.82,0.78,0.94c0.94,0.55,2.09,0.17,2.62-0.87c0.49-0.95,0.5-14.44,0.02-15.39
            C136.38,69.87,135.72,69.53,135.05,69.54L135.05,69.54z"
      ></path>
      <path
        class="st6 line4"
        d="M141.7,54.57c-0.31-0.02-0.64,0.06-0.98,0.22c-1.49,0.71-1.42-0.41-1.42,23.52c0,20.12,0.03,21.66,0.39,22.38
            c0.21,0.43,0.64,0.9,0.95,1.06c0.03,0.02,0.05,0.03,0.06,0.04l1.68-0.02c0-0.02,0.03-0.05,0.08-0.07c1.35-0.73,1.31-0.05,1.31-23.5
            c0-20.31-0.02-21.41-0.42-22.28C142.95,55.07,142.38,54.6,141.7,54.57L141.7,54.57z"
      ></path>
      <path
        class="st6 line5"
        d="M147.55,62.94c-0.85,0.01-1.67,0.67-2,1.84c-0.13,0.46-0.22,5.98-0.21,13.82c0,12.31,0.03,13.11,0.42,13.98
            c0.23,0.51,0.61,1.03,0.83,1.17c0.9,0.52,2.13,0.13,2.63-0.84c0.3-0.58,0.34-2.46,0.34-14.61V64.35l-0.58-0.69
            C148.57,63.16,148.06,62.93,147.55,62.94z"
      ></path>
      <path
        class="st6 line6"
        d="M153.75,72.04c-0.58,0.02-1.08,0.35-1.6,1.05c-0.43,0.58-0.47,0.98-0.54,4.86c-0.07,3.92-0.04,4.3,0.39,5.2
            c0.26,0.53,0.69,1.08,0.97,1.21c1,0.48,1.98,0.15,2.62-0.9c0.4-0.66,0.45-1.13,0.45-5.03c0-4.98-0.16-5.66-1.45-6.2
            C154.29,72.09,154.01,72.03,153.75,72.04z"
      ></path>
      <path
        class="st6 line7"
        d="M160.34,69.42c-0.24,0-0.49,0.05-0.74,0.15c-1.29,0.53-1.33,0.82-1.32,8.63c0.01,7.58,0.04,7.86,1.13,8.46
            c1.19,0.66,2.46,0.02,2.87-1.43c0.13-0.48,0.23-3.5,0.23-7.19c0-5.71-0.05-6.45-0.42-7.27C161.69,69.91,161.06,69.43,160.34,69.42z"
      ></path>
      <path
        class="st6 line8"
        d="M166.78,75.33c-0.27,0.01-0.55,0.08-0.84,0.22c-1.8,0.86-1.87,4.21-0.11,5.16c0.75,0.41,1.02,0.41,1.78,0.02
            c0.85-0.44,1.27-1.34,1.25-2.68C168.84,76.38,167.94,75.29,166.78,75.33L166.78,75.33z"
      ></path>
    </svg>
  </div>
</template>
<script>
export default {
  name: "AnimatedLogo"
};
</script>


<style scoped>
svg {
  width: 250px;
}
</style>

<style>
.st6 {
  transform: translateY(0px);
}

.line1 { animation: up-and-down-1 2s 2 3.5s forwards; }
.line2 { animation: up-and-down-2 2s 2 3.5s forwards; }
.line3 { animation: up-and-down-3 2s 2 3.5s forwards; }
.line4{ animation:  up-and-down-4 2s 2 3.5s forwards; }
.line5 { animation: up-and-down-5 2s 2 3.5s forwards; }
.line6 { animation: up-and-down-6 2s 2 3.5s forwards; }
.line7 { animation: up-and-down-7 2s 2 3.5s forwards; }
.line8 { animation: up-and-down-8 2s 2 3.5s forwards; }

.st0 {
  fill: #00ccff;
}
.st1 {
  fill: #2a3d50;
}
.st2 {
  fill: #31c4f3;
}
.st3 {
  fill: #0ab0e2;
}
.st4 {
  fill: #099ecb;
}
.st5 {
  fill: #088cb3;
}
.st6 {
  fill: #ffffff;
}

@keyframes up-and-down-1 {
  0% {
    transform: translateY(0px);
  }
  20% {
    transform: translateY(4px);
  }
  40% {
    transform: translateY(-4px);
  }
  100% {
    transform: translateY(0);
  }
}
@keyframes up-and-down-2 {
  0% {
    transform: translateY(0);
  }
  30% {
    transform: translateY(4px);
  }
  50% {
    transform: translateY(-4px);
  }
  100% {
    transform: translateY(0);
  }
}
@keyframes up-and-down-3 {
  0% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(4px);
  }
  60% {
    transform: translateY(-4px);
  }
  100% {
    transform: translateY(0);
  }
}
@keyframes up-and-down-4 {
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(4px);
  }
  70% {
    transform: translateY(-4px);
  }
  100% {
    transform: translateY(0);
  }
}
@keyframes up-and-down-5 {
  0% {
    transform: translateY(0);
  }
  60% {
    transform: translateY(4px);
  }
  80% {
    transform: translateY(-4px);
  }
  100% {
    transform: translateY(0);
  }
}
@keyframes up-and-down-6 {
  0% {
    transform: translateY(0);
  }
  70% {
    transform: translateY(4px);
  }
  90% {
    transform: translateY(-4px);
  }
  100% {
    transform: translateY(0);
  }
}
@keyframes up-and-down-7 {
  0% {
    transform: translateY(0);
  }
  20% {
    transform: translateY(4px);
  }
  40% {
    transform: translateY(-4px);
  }
  100% {
    transform: translateY(0);
  }
}
@keyframes up-and-down-8 {
  0% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(4px);
  }
  70% {
    transform: translateY(-4px);
  }
  100% {
    transform: translateY(0);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/animated-logo.vue